import React, { useState, useEffect, useRef } from "react";
import "./Components.css";

const CustomTimePicker = ({ value, onChange, allow24Hour = true }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const pickerRef = useRef(null);

  // Derive initial hour/minute from value, default to 08:00
  const [selectedHour, setSelectedHour] = useState(value ? value.split(":")[0] : "08");
  const [selectedMinute, setSelectedMinute] = useState(value ? value.split(":")[1] : "00");

  // Hours list: 00..23 (and optionally 24)
  const hours = Array.from({ length: allow24Hour ? 25 : 24 }, (_, i) =>
    i < 10 ? `0${i}` : `${i}`
  );

  // Minutes: if hour === "24", only "00" is valid
  const minutes = selectedHour === "24" ? ["00"] : ["00", "30"];

  const handleTimeSelect = (hour, minute) => {
    const h = hour;
    const m = hour === "24" ? "00" : minute; // clamp to 00 at 24
    setSelectedHour(h);
    setSelectedMinute(m);
    onChange(`${h}:${m}`);
    setShowDropdown(false);
  };

  // Close dropdown if clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    if (showDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showDropdown]);

  // Keep internal state in sync with incoming prop
  useEffect(() => {
    if (value && typeof value === "string" && value.includes(":")) {
      let [h, m] = value.split(":");
      if (h === "24") m = "00"; // sanitize any accidental 24:xx to 24:00
      setSelectedHour(h.padStart(2, "0"));
      setSelectedMinute(m.padStart(2, "0"));
    }
  }, [value]);

  return (
    <div className="custom-time-picker" ref={pickerRef}>
      <div className="time-display" onClick={() => setShowDropdown(!showDropdown)}>
        {selectedHour}:{selectedMinute}
      </div>
      {showDropdown && (
        <div className="dropdown">
          <div className="column">
            {hours.map((hour) => (
              <div
                key={hour}
                className={`time-option ${hour === selectedHour ? "selected" : ""}`}
                onClick={() => handleTimeSelect(hour, selectedMinute)}
              >
                {hour}
              </div>
            ))}
          </div>
          <div className="column">
            {minutes.map((minute) => (
              <div
                key={minute}
                className={`time-option ${minute === selectedMinute ? "selected" : ""}`}
                onClick={() => handleTimeSelect(selectedHour, minute)}
              >
                {minute}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomTimePicker;
